import A from '../actions/endorsementsActions';
import moment from 'moment';

const init = {
    data: null,
    loading: false,
    inError: false,
    loadTime: undefined,
    hasEndorsements: false,
    pagingData: {
        total: 0,
        page: 1, 
        pageSize: 10,
        sort: null,
        column: null,
        search: ''
    }
}

export default (state=init, action) => {
    switch(action.type) {
        case A.ENDORSEMENTS_SEARCH_ADD:
            return { ...state,
                pagingData: { ...state.pagingData,
                    search: action.text
                }
            };

        case A.ENDORSEMENTS_PAGING_CHANGE:
            return { ...state,
                pagingData: {...state.pagingData,
                    ...action.pagingData
                }
            };

        case A.ENDORSEMENTS_DATA_REQUEST_PENDING:
            return {...state, 
                data: {},
                loading: true,
                inError: false
            };

        case A.ENDORSEMENTS_DATA_REQUEST_SUCCESS:
            return {...state,
                data: action.payload.personCollection.map((p, i) => ({...p, key: i + 1 })),
                loading: false,
                inError: false,
                loadTime: moment.utc().unix(),
                hasEndorsements: action.payload.hasEndorsements,
                pagingData: {...state.pagingData,
                    total: action.payload.total
                }
            };

        case A.ENDORSEMENTS_DATA_REQUEST_FAILURE:
            return {...state,
                loading: false,
                inError: true,
                loadTime: undefined,
                hasEndorsements: (action.payload && action.payload.response) ? action.payload.response.hasEndorsements : state.hasEndorsements
            };

        default: return {...state};
    }
}